import Swiper, { Pagination, Thumbs } from 'swiper';

const params = {
    containerSelector: '.js-product-slider .product-slider__slider .swiper-container',
    paginationSelector: '.js-product-slider .product-slider__slider .swiper-pagination',
    thumbsSelector: '.js-product-slider .product-slider__thumbs .swiper-container',
};

Swiper.use([Pagination, Thumbs]);

export function initProductSlider() {
    const container = $(params.containerSelector)[0];
    const thumbs = $(params.thumbsSelector)[0];

    const isEquipment = !!$(container).closest('.product-slider--equipment')?.length;

    if (!container) {
        return;
    }

    let swiperOptions = {
        cssMode: true,
        pagination: {
            el: params.paginationSelector,
            clickable: true,
        },
    };

    if (!isEquipment) {
        swiperOptions = {
            ...swiperOptions,
            speed: 500,
            slidesPerView: 1,
            breakpoints: {
                576: {
                    slidesPerView: 2,
                },
            },
        };
    }

    if (thumbs) {
        const productThumbs = new Swiper(thumbs, {
            spaceBetween: 10,
            slidesPerView: 4,
            cssMode: true,
        });

        swiperOptions = {
            ...swiperOptions,
            thumbs: {
                swiper: productThumbs,
            },
        };
    }

    const productSwiper = new Swiper(container, swiperOptions);

    productSwiper.on('slideChange', (e) => {
        // eslint-disable-next-line prefer-rest-params
        console.log(e);
    });
}
